import { cdnUrl } from "@/utils/backend";

type ImageSize = {
    width?: number;
    height?: number;
};

type ImageUrlBaseOptions = {
    imageId?: string | null;
    fit?: Fit;
};

export type Fit =
    // Don't crop the image, only one of width and height will be respected
    | "clip"
    // Crop the image to fit the specified dimensions
    | "crop"
    // Scale the image to fit the specified dimensions. Aspect ratio will not be preserved
    | "scale";

type GenerateImageUrlOptions = ImageSize & ImageUrlBaseOptions;

export function generateImageUrl({
    imageId,
    width,
    height,
    fit = "crop",
}: GenerateImageUrlOptions) {
    if (!width && !height) {
        throw new Error("Need to set either width or height");
    }

    if (
        !(
            (!width || width % 10 === 0 || width % 8 === 0 || (width % 4 === 0 && width < 64)) &&
            (!height || height % 10 === 0 || height % 8 === 0 || (height % 4 === 0 && height < 64))
        )
    ) {
        if (width) {
            width = getNearestValidImageDimension(width);
        }

        if (height) {
            height = getNearestValidImageDimension(height);
        }
    }

    let imageUrl = `${cdnUrl()}/images/${imageId}`;
    const params = new URLSearchParams();

    if (width !== undefined) {
        params.append("w", width.toString());
    }

    if (height !== undefined) {
        params.append("h", height.toString());
    }

    params.append("fit", fit);

    const queryString = params.toString();
    if (queryString) {
        imageUrl += `?${queryString}`;
    }

    return imageUrl;
}

export const getNearestValidImageDimension = (dimension: number) => {
    if (dimension % 4 === 0 && dimension < 64) {
        return dimension;
    }

    if (dimension % 8 === 0) {
        return dimension;
    }

    return Math.ceil(dimension / 10) * 10;
};
